import { Button, styled } from '@mui/material'
import { LastPriceButton } from 'components/Buttons/LastPriceButton'
import InputAmount from 'components/InputAmount'
import { memo } from 'react'
import { TokenSymbol } from 'types'
import { StyledControlInput } from '../../styles/Control'
import Decimal from 'decimal.js'

export const QuoteSymbol = styled('div')`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.color.text50};
  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`

export const InputIncrementButton = styled(Button)`
  width: 36px;
  position: relative;
  font-weight: normal;
  font-size: 22px;
  color: ${(props) => props.theme.color.text40};
  display: none;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: flex;
  }
  &:before {
    display: block;
    content: '';
    width: 1px;
    height: 24px;
    background: ${(props) => props.theme.color.text40};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
`

export const AddButton = styled(InputIncrementButton)`
  &:before {
    left: 0;
  }
`
export const SubtractButton = styled(InputIncrementButton)`
  &:before {
    right: 0;
  }
`

export const LimitPriceInput = memo<{
  currentPrice: string
  quoteCurrency: TokenSymbol
  quoteMinimumIncrement: number
  onChangePrice: (price: string) => void
}>(({ currentPrice, quoteCurrency, quoteMinimumIncrement, onChangePrice }) => {
  currentPrice = currentPrice ?? ''
  quoteCurrency = quoteCurrency ?? ''
  quoteMinimumIncrement = quoteMinimumIncrement ?? 0

  const onMobilePriceInput = (price: string) => {
    if (+price < 0) {
      return
    }
    onChangePrice(price)
  }

  return (
    <StyledControlInput>
      {/* <SubtractButton
        onClick={() =>
          onMobilePriceInput(
            Decimal.sub(currentPrice, quoteMinimumIncrement).toFixed(),
          )
        }
      >
        -
      </SubtractButton> */}
      <InputAmount
        value={currentPrice}
        placeholder={'Price'}
        onInput={onChangePrice}
      />
      <div className="input-border" />
      <LastPriceButton onHandleClick={onChangePrice} />
      <QuoteSymbol>{quoteCurrency}</QuoteSymbol>
      {/* <AddButton
        onClick={() =>
          onMobilePriceInput(
            Decimal.add(currentPrice, quoteMinimumIncrement).toFixed(),
          )
        }
      >
        +
      </AddButton> */}
    </StyledControlInput>
  )
})
